// Catalogue de séances adultes et ambiances bébé.
// Les scripts sont des contenus de démonstration à faire relire avant publication.

export const NEEDS = [
  { id: "pause", label: "Pause rapide", hint: "Entre deux rendez-vous" },
  { id: "tensions", label: "Tensions", hint: "Corps noué, épaules serrées" },
  { id: "pression", label: "Pression professionnelle", hint: "Journée intense" },
  { id: "decompression", label: "Décompression", hint: "Après le travail" },
  { id: "soiree", label: "Après une soirée", hint: "Redescendre en douceur" },
  { id: "sommeil", label: "Préparation au sommeil", hint: "Transition vers la nuit" },
  { id: "sport", label: "Après le sport", hint: "Retrouver le calme après l'effort" },
];

export const DURATIONS = [3, 5, 10, 20];

export const PREFERENCES = [
  { id: "guide", label: "Exercice guidé" },
  { id: "ambiance", label: "Ambiance sonore" },
  { id: "combi", label: "Les deux combinés" },
];

// Scripts brefs — texte synchronisé (avec timings en secondes)
const scriptRespiration = [
  { t: 0, text: "Installez-vous confortablement. Sans forcer." },
  { t: 6, text: "Laissez l'air entrer doucement par le nez." },
  { t: 12, text: "Puis relâchez, lentement, par la bouche." },
  { t: 20, text: "Suivez le cercle : il grandit à l'inspiration, se rétracte à l'expiration." },
  { t: 34, text: "Si le rythme ne vous convient pas, respirez naturellement." },
  { t: 60, text: "Restez présent à cette sensation d'air qui va et vient." },
  { t: 120, text: "Vous pouvez arrêter à tout moment, sans pression." },
];

const scriptTensions = [
  { t: 0, text: "Fermez les yeux si vous le souhaitez." },
  { t: 6, text: "Portez l'attention sur vos mains. Contractez légèrement. Puis relâchez." },
  { t: 25, text: "Remontez vers les épaules. Une petite tension. Relâchez complètement." },
  { t: 55, text: "Le visage : mâchoire, front. Serrez à peine. Laissez fondre." },
  { t: 90, text: "Descendez vers les jambes. Contractez. Relâchez." },
  { t: 140, text: "Sautez toute zone douloureuse. Ne forcez jamais." },
  { t: 220, text: "Restez avec la sensation de relâchement quelques instants." },
];

const scriptPresent = [
  { t: 0, text: "Yeux ouverts ou fermés, comme vous préférez." },
  { t: 6, text: "Écoutez les sons autour de vous, sans les nommer." },
  { t: 30, text: "Sentez le contact du sol, du siège, de vos vêtements." },
  { t: 70, text: "Percevez la température de l'air sur votre peau." },
  { t: 120, text: "Chaque fois que l'esprit part, revenez simplement aux sensations." },
  { t: 210, text: "Restez ici, encore un instant." },
];

const scriptDecompress = [
  { t: 0, text: "Posez le téléphone à distance quand vous êtes prêt." },
  { t: 8, text: "Trois respirations un peu plus profondes que d'habitude." },
  { t: 30, text: "Laissez l'idée du travail se déposer, sans la repousser." },
  { t: 90, text: "Nommez mentalement une chose qui vous a coûté aujourd'hui." },
  { t: 150, text: "Puis une chose qui a été plus facile que prévu." },
  { t: 240, text: "Revenez au souffle. Doucement." },
  { t: 420, text: "La journée peut se terminer ici." },
];

const scriptNuit = [
  { t: 0, text: "Éteignez ou tamisez les lumières." },
  { t: 10, text: "Allongez-vous ou installez-vous confortablement." },
  { t: 30, text: "Sentez le poids du corps qui se dépose." },
  { t: 90, text: "Respiration lente et confortable, sans effort." },
  { t: 240, text: "Si des pensées passent, laissez-les traverser." },
  { t: 600, text: "Votre esprit peut ralentir maintenant." },
  { t: 900, text: "Rien à faire. Rien à attendre." },
];

export const SESSIONS = [
  {
    id: "pause-3",
    title: "Pause entre deux rendez-vous",
    minutes: 3,
    tags: ["pause"],
    prefs: ["guide", "combi"],
    method: "breathing",
    ambient: "pink",
    script: scriptRespiration,
    breath: { inhale: 4, hold: 2, exhale: 6 },
    description: "Une courte respiration douce pour reposer l'attention.",
  },
  {
    id: "respiration-5",
    title: "Respiration douce",
    minutes: 5,
    tags: ["pause", "pression", "tensions"],
    prefs: ["guide", "combi"],
    method: "breathing",
    ambient: "pink",
    script: scriptRespiration,
    breath: { inhale: 4, hold: 2, exhale: 6 },
    description: "Un rythme confortable, sans apnée, sans respiration forcée.",
  },
  {
    id: "present-5",
    title: "Revenir au présent",
    minutes: 5,
    tags: ["pression", "decompression", "soiree"],
    prefs: ["guide", "combi"],
    method: "presence",
    ambient: "rain",
    script: scriptPresent,
    description: "Observer simplement les sensations et les sons, yeux ouverts possibles.",
  },
  {
    id: "tensions-10",
    title: "Relâcher les tensions",
    minutes: 10,
    tags: ["tensions", "pression"],
    prefs: ["guide", "combi"],
    method: "pmr",
    ambient: "brown",
    script: scriptTensions,
    description: "Relaxation musculaire progressive. Sautez toute zone douloureuse.",
  },
  {
    id: "decompress-10",
    title: "Décompresser après le travail",
    minutes: 10,
    tags: ["decompression", "pression"],
    prefs: ["guide", "combi"],
    method: "presence",
    ambient: "ocean",
    script: scriptDecompress,
    description: "Poser la journée, revenir à soi.",
  },
  {
    id: "nuit-20",
    title: "Transition vers la nuit",
    minutes: 20,
    tags: ["sommeil", "soiree"],
    prefs: ["guide", "ambiance", "combi"],
    method: "breathing",
    ambient: "brown",
    script: scriptNuit,
    breath: { inhale: 4, hold: 4, exhale: 8 },
    description: "Ralentir doucement, sans promesse d'endormissement.",
  },
  {
    id: "sport-5",
    title: "Après le sport — 5 min",
    minutes: 5,
    tags: ["sport"],
    prefs: ["ambiance"],
    method: "ambient",
    ambient: "ocean",
    script: [],
    fadeOut: true,
    description: "Une pause musicale douce pour retrouver le calme après l'effort.",
  },
  {
    id: "sport-10",
    title: "Après le sport — 10 min",
    minutes: 10,
    tags: ["sport"],
    prefs: ["ambiance"],
    method: "ambient",
    ambient: "ocean",
    script: [],
    fadeOut: true,
    description: "Ambiance enveloppante qui s'apaise progressivement.",
  },
  {
    id: "sport-20",
    title: "Après le sport — 20 min",
    minutes: 20,
    tags: ["sport"],
    prefs: ["ambiance"],
    method: "ambient",
    ambient: "ocean",
    script: [],
    fadeOut: true,
    description: "Longue transition sonore après une séance intense.",
  },
];

export const AMBIENTS = [
  { id: "pink", label: "Bruit rose", description: "Un souffle continu, plus doux que le bruit blanc." },
  { id: "brown", label: "Bruit brun", description: "Un grondement grave et enveloppant." },
  { id: "rain", label: "Pluie douce", description: "Pluie synthétique légère, générée en direct." },
  { id: "ocean", label: "Océan", description: "Vagues lentes, générées en direct." },
];

// Catégories affichées sur l'accueil. Chacune filtre la liste de séances.
// `mode: 'ambient'` = catalogue d'ambiances musique douce. `mode: 'baby'` = espace bébé.
// Illustrations propriétaires générées par IA (Gemini Nano Banana) — style aquarelle.
const IMG = (name) => `/illustrations/${name}.png`;

export const HERO_IMAGE = IMG("hero");

export const CATEGORIES = [
  {
    id: "pression",
    label: "Stress au travail",
    description: "Décharger la pression en pleine journée.",
    image: IMG("pression"),
    need: "pression",
  },
  {
    id: "decompression",
    label: "Après le travail",
    description: "Poser la journée, revenir à soi.",
    image: IMG("decompression"),
    need: "decompression",
  },
  {
    id: "soiree",
    label: "Après une soirée",
    description: "Redescendre en douceur.",
    image: IMG("soiree"),
    tags: ["soiree"],
  },
  {
    id: "pause",
    label: "Pause rapide",
    description: "3 minutes suffisent parfois.",
    image: IMG("pause"),
    need: "pause",
  },
  {
    id: "tensions",
    label: "Tensions du corps",
    description: "Relâcher les épaules et le dos.",
    image: IMG("tensions"),
    need: "tensions",
  },
  {
    id: "sommeil",
    label: "Transition vers la nuit",
    description: "Ralentir avant de dormir.",
    image: IMG("sommeil"),
    need: "sommeil",
  },
  {
    id: "sport",
    label: "Après le sport",
    description: "Une pause en musique pour retrouver le calme après l'effort.",
    image: IMG("sport"),
    tags: ["sport"],
  },
  {
    id: "musique",
    label: "Musique douce & ASMR",
    description: "Ambiances sonores générées en direct.",
    image: IMG("musique"),
    mode: "ambient",
  },
  {
    id: "bebe",
    label: "Ambiance pour bébé",
    description: "Sons uniquement, pour parents avertis.",
    image: IMG("bebe"),
    mode: "baby",
  },
];

// Ambiances bébé — sons uniquement, sans exercice ni animation destinée au bébé
export const BABY_AMBIENTS = [
  { id: "pink", label: "Bruit rose", description: "Continu, doux, souvent utilisé pour couvrir les bruits environnants." },
  { id: "brown", label: "Bruit brun", description: "Grave et enveloppant." },
  { id: "rain", label: "Pluie douce", description: "Générée en direct." },
];

export const BABY_DURATIONS = [5, 10, 15];

/**
 * Sélection basée sur besoin + durée + préférence.
 * Ne renvoie JAMAIS un tableau vide : si aucune séance ne correspond
 * exactement, la plus proche est retournée avec un indicateur `mismatch`.
 */
export function suggestSessions({ need, minutes, preference }) {
  const filtered = SESSIONS
    .filter((s) => (need ? s.tags.includes(need) : true))
    .filter((s) => (minutes ? s.minutes <= minutes : true))
    .filter((s) => (preference ? s.prefs.includes(preference) : true));

  if (filtered.length > 0) {
    return filtered.sort((a, b) => Math.abs(a.minutes - (minutes || 5)) - Math.abs(b.minutes - (minutes || 5)));
  }

  // Fallback progressif : besoin d'abord, puis durée, puis préférence
  const byNeed = SESSIONS.filter((s) => (need ? s.tags.includes(need) : true));
  if (byNeed.length > 0) {
    return byNeed
      .map((s) => ({ ...s, _mismatch: true }))
      .sort((a, b) => Math.abs(a.minutes - (minutes || 5)) - Math.abs(b.minutes - (minutes || 5)));
  }
  // Aucun match sur le besoin — proposer les séances les plus proches en durée
  return [...SESSIONS]
    .map((s) => ({ ...s, _mismatch: true }))
    .sort((a, b) => Math.abs(a.minutes - (minutes || 5)) - Math.abs(b.minutes - (minutes || 5)))
    .slice(0, 3);
}

/**
 * Filtre les séances par catégorie choisie sur l'accueil.
 */
export function sessionsForCategory(catId) {
  const cat = CATEGORIES.find((c) => c.id === catId);
  if (!cat) return SESSIONS;
  if (cat.mode) return []; // catégories spéciales (musique/bebe) traitées ailleurs
  if (cat.tags) {
    return SESSIONS.filter((s) => cat.tags.some((t) => s.tags.includes(t)));
  }
  if (cat.need) return SESSIONS.filter((s) => s.tags.includes(cat.need));
  return SESSIONS;
}
